"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This class simply takes an element, records its size, and then polls it for
 * size changes every 500 ms. If a size change is detected the onSizeChanged
 * callback is called.
 */
class ElementSizeChangePoller {
    /**
     * Constructs a new instance, but initially it won't know which element to
     * watch. You have to call `update` to pass it the element.
     *
     * @param onSizeChanged Callback to call when a watched element's size changes.
     */
    constructor(onSizeChanged) {
        this.onSizeChanged = onSizeChanged;
        this.start = () => {
            var _a;
            // Just in case...
            if (this.timerId) {
                this.stop();
            }
            this.oldSize = (_a = this.element) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            this.timerId = setInterval(() => {
                if (!this.element || !this.oldSize) {
                    return;
                }
                const { width, height } = this.element.getBoundingClientRect();
                if (width !== this.oldSize.width || height !== this.oldSize.height) {
                    this.onSizeChanged();
                }
            }, 500);
        };
        this.stop = () => {
            if (this.timerId) {
                clearInterval(this.timerId);
            }
            this.timerId = undefined;
        };
        this.polling = false;
    }
    /**
     * Stops polling and clears the element that was being watched.
     */
    reset() {
        this.update(undefined, false);
    }
    /**
     * Changes the element being watched and starts or stops polling for size
     * changes.
     */
    update(element, polling) {
        this.element = element;
        this.polling = polling;
        this.stop();
        if (this.element && this.polling) {
            this.start();
        }
    }
}
exports.ElementSizeChangePoller = ElementSizeChangePoller;
//# sourceMappingURL=ElementSizeChangePoller.js.map